const DefaultLayout = ({ children }) => children;

export default DefaultLayout;
